import { useSnackbar } from 'notistack'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'

import { useMutation } from 'providers/tanstack-query/useMutation'
import { UPDATE_AD_UNIT_PRODUCT_ENABLED } from './api/mutation'
import { Data, Variables } from './api/types'
import { SwitchVariables, UseSwitchAdUnitProduct, useSwitchAdUnitProductProps } from './types'

export const useSwitchAdUnitProduct = ({
  setLoading,
}: useSwitchAdUnitProductProps): UseSwitchAdUnitProduct => {
  const { t } = useTranslation('features/adUnit')
  const { enqueueSnackbar } = useSnackbar()

  const { isPending, mutateAsync } = useMutation<{ input: Variables }, Data>({
    mutation: UPDATE_AD_UNIT_PRODUCT_ENABLED,
    onCompleted: async (data: Data) => {
      const {
        updateAdUnitProductEnabled: { errors },
      } = data

      if (errors && errors.length > 0) {
        enqueueSnackbar(t('form.error.update'), { variant: 'error' })
      } else {
        enqueueSnackbar(t('form.success.update'), { variant: 'success' })
      }
    },
    queriesToInvalidate: ['adUnit'],
  })

  useEffect(() => {
    setLoading(isPending)
  }, [isPending])

  const mapper = ({ id, product, value }: SwitchVariables): Variables => ({
    enabledValue: value,
    id,
    productType: product,
  })

  const update = (variables: SwitchVariables): void => {
    mutateAsync({
      input: mapper(variables),
    })
  }

  return { update }
}
